module.exports = __webpack_public_path__ + "img/unknown.ba2124ee.svg";